"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tauDependencies = void 0;

var _dependenciesBigNumberClassGenerated = require("./dependenciesBigNumberClass.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var tauDependencies = {
  BigNumberDependencies: _dependenciesBigNumberClassGenerated.BigNumberDependencies,
  createTau: _factoriesAny.createTau
};
exports.tauDependencies = tauDependencies;